import {cloneDeep, isEqual} from 'lodash-es'
class Entity {
    static defaults = {
        'created_at': null,
        'updated_at': null,
        'deleted_at': null,
    }
    static dates = [
        'updated_at',
        'created_at',
        'deleted_at'
    ]

    constructor(attributes = {}) {

        this.attributes = {};
        this.setAttributes({...this.constructor.defaults, ...attributes});

        this.original = {};
        this.setOriginal(this.attributes);

        for (const attr in this.attributes) {
            this.defineAttributeGettersAndSetters(attr)
        }
    }

    setAttributes(attributes) {
        this.attributes = cloneDeep(attributes);
    }

    setOriginal(attributes) {
        this.original = cloneDeep(attributes);
    }

    defineAttributeGettersAndSetters(attr)
    {
        let setter = (value) => {
            this.attributes[attr] = value
        }

        let getter = () => {
            return this.attributes[attr]
        }

        if (this.constructor.dates.includes(attr)) {
            getter = () => (this.attributes[attr]) ? new Date(Date.parse(this.attributes[attr])) : null;
            setter = (value) => {
                this.attributes[attr] = (value) ? new Date(Date.parse(value)) : null;
            }
        }

        Object.defineProperty(
            this,
            attr,
            {
                get: getter,
                set: setter
            }
        );
    }

    setAttribute(attr, value=null) {
        if (typeof Object.getOwnPropertyDescriptor(this, attr) == 'undefined') {
            this.defineAttributeGettersAndSetters(attr);
        }

        this[attr] = value;
    }

    isPersisted() {
        return Boolean(this.attributes.id)
    }

    clone(){
        return new this.constructor(this.attributes);
    }

    getAttributes() {
        return this.attributes;
    }

    /**
     *
     * TODO: dirty & original need to support nested objects.  currently this is not the case.
     */
    getOriginal() {
        return this.original;
    }

    clearChanges() {
        this.original = {};
    }

    isDirty(attribute = null) {
        const keys = Object.keys(this.original);
        const same = (a, b) => {
            const norm = v => (v instanceof Date ? v.toISOString() : v);
            return isEqual(norm(a), norm(b));
        };

        if (attribute) {
            if (!keys.includes(attribute)) return false;
            return !same(this.original[attribute], this.attributes[attribute]);
        }
        
        const compareKeys = keys.filter(k => !this.constructor.dates.includes(k));
        return compareKeys.some(k => !same(this.original[k], this.attributes[k]));
    }


    getDirty(attribute = null) {
        if (!this.isDirty(attribute)) return {};
        let keys = Object.keys(this.original);
        if (attribute) {
            keys = Array.isArray(attribute) ? attribute : [attribute];
        } else {
            keys = keys.filter(k => !this.constructor.dates.includes(k));
        }
        const dirty = {};
        keys.forEach(key => {
            if (this.isDirty(key)) {
                dirty[key] = { original: this.original[key], new: this.attributes[key] };
            }
        });
        return dirty;
    }

    revertDirty (fields = null) {
        if (!fields) {
            this.attributes = cloneDeep(this.original);
            this.setOriginal(this.attributes);
            return;
        }
        const list = Array.isArray(fields) ? fields : [fields];
        list.forEach(k => {
            if (k in this.original) {
            this.attributes[k] = cloneDeep(this.original[k]);
            }
        });
        this.markClean(list);
    }

    
    /** This function is to seset the dirty baseline. If fields passed, only reset those. */
    markClean(fields = null) {
        if (!fields) {
            this.original = cloneDeep(this.attributes);
            return;
        }
        const list = Array.isArray(fields) ? fields : [fields];
        list.forEach(k => {
            this.original[k] = cloneDeep(this.attributes[k]);
        });
    }

    /** And this one is to replace the whole object with a fresh snapshot (use when refetching). */
    replaceAttributes(attrs) {
        this.attributes = cloneDeep(attrs);
        this.original   = cloneDeep(attrs);
    }

}


export default Entity;
